import {Injectable} from '@angular/core';

@Injectable()
export class PageNameService {
  public getPageName(): string {
    const urlpath = window.location.href;
    if (urlpath.includes('premium')) {
      return 'premium';
    } else if (urlpath.includes('super-cruise')) {
      return 'Super Cruise';
    } else if (urlpath.includes('safety-security')) {
      return 'safety-security';
    } else if (urlpath.includes('signature')) {
      return 'Themes:Signature';
    } else if (urlpath.includes('remote-access')) {
      return 'Remote Access';
    } else if (urlpath.includes('data')) {
      return 'Data';
    } else if (urlpath.includes('app-access')) {
      return 'App Access';
    } else if (urlpath.includes('guardian')) {
      return 'Guardian';
    } else if (urlpath.includes('essentials')) {
      return 'Essentials';
    } else if (urlpath.includes('connected-vehicle')) {
      return 'Connected Vehicle';
    } else if (urlpath.includes('preferred')) {
      return 'OnStar Preferred (US)';
    } else if (urlpath.includes('preferred-plus-wifi')) {
      return 'OnStar Preferred Plus WiFi';
    } else if (urlpath.includes('protection')) {
      return 'Protection';
    } else if (urlpath.includes('super-cruise-trailering')) {
      return 'Super Cruise Trailering';
    } else if (urlpath.includes('super-cruise-automatic-lane-change')) {
      return 'Super Cruise Automatic Lane Change';
    } else if (urlpath.includes('super-cruise-auto-lane-change-trailering')) {
      return 'Super Cruise Auto Lane Change and Trailering';
    }
    return 'Plan Details';
  }
}
